import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ba77d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-3" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Lojas", -1))
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Automoções", -1))
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "CNPJ", -1))
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Data", -1))
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Filtro", -1))
const _hoisted_12 = { class: "w-100 d-flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "users",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            modelValue: _ctx.filtro.lojas,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtro.lojas) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            class: "m-0",
            placeholder: "Selecione um cargo...",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: loja.codConcessionaria,
                  label: loja.nome,
                  value: loja.codConcessionaria
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_select, {
            modelValue: _ctx.filtro.automocoes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtro.automocoes) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            class: "m-0",
            placeholder: "Selecione um cargo...",
            size: "large"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.automocoes, (automocao) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: automocao.id,
                  label: automocao.nome,
                  value: automocao.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createVNode(_component_el_input, {
            onKeyup: _cache[2] || (_cache[2] = e => e.key === 'Enter'),
            clearable: "",
            placeholder: "Digite...",
            maxlength: "18",
            class: "m-0",
            modelValue: _ctx.filtro.cnpj,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtro.cnpj) = $event))
          }, null, 8, ["modelValue"]), [
            [_directive_maska, { mask: '##.###.###/####-##' }]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filtro.data,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtro.data) = $event)),
                type: "daterange",
                format: "DD/MM/YYYY",
                "value-format": "YYYY/MM/DD",
                class: "w-100",
                style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","height":"36px"},
                "start-placeholder": "inicial",
                "end-placeholder": "final",
                "default-value": [new Date(), new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filtro.comErro = null)),
              style: _normalizeStyle(_ctx.filtro.comErro == null ? 'opacity: 1' : 'opacity: .25'),
              class: "btn btn-danger d-flex flex-row gap-3 py-2 justify-content-center align-items-center w-100"
            }, "Todos", 4),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filtro.comErro = true)),
              style: _normalizeStyle(_ctx.filtro.comErro == true ? 'opacity: 1' : 'opacity: .25'),
              class: "btn btn-danger d-flex flex-row gap-3 py-2 justify-content-center align-items-center w-100"
            }, "Com erro", 4),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filtro.comErro = false)),
              style: _normalizeStyle(_ctx.filtro.comErro == false ? 'opacity: 1' : 'opacity: .25'),
              class: "btn btn-danger d-flex flex-row gap-3 py-2 justify-content-center align-items-center w-100"
            }, "Sem erro", 4)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}